import axios from 'axios'
import './axiosConfig'

const API_BASE_URL = import.meta.env.VITE_API_URL

/**
 * Whether the Gateway lets the signed-in user edit the site. The Gateway answers from the
 * user's own e-mail address: only an address at @rimonim.tech may. The login answer carries
 * no e-mail, so this is the one place the real address decides.
 */
export const getSiteCanEdit = async (siteId: string | number): Promise<boolean> =>
  (await axios.get(`${API_BASE_URL}/api/sites/${siteId}/settings`)).data?.data?.canEdit === true
